function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTombstone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#90BC42",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M50.746,451.598v-2.505c0-24.811,9.856-48.605,27.399-66.149l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#90BC42",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M23.347,349.942L23.347,349.942c17.544,17.544,27.399,41.338,27.399,66.149v35.507c0,0-6.624-40.599-42.493-50.501"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#90BC42",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M461.253,451.598v-2.505c0-24.811-9.856-48.605-27.399-66.149l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#90BC42",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M488.652,349.942L488.652,349.942c-17.544,17.544-27.399,41.338-27.399,66.149v35.507c0,0,6.624-40.599,42.493-50.501"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27214"
    },
    d: "M503.692,477.602H8.304c29.341-18.923,60.993-34.578,94.426-46.449 c47.923-17.03,99.509-26.305,153.274-26.305s105.351,9.274,153.263,26.305C442.7,443.035,474.351,458.679,503.692,477.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M409.266,187.678v243.475c-47.912-17.03-99.498-26.305-153.263-26.305s-105.351,9.274-153.274,26.305 V187.678c0-84.646,68.617-153.274,153.263-153.274C340.649,34.404,409.266,103.032,409.266,187.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M130.234,187.678c0-69.349,56.415-125.77,125.759-125.77c69.349,0,125.769,56.42,125.769,125.77 v206.135c-40.827-10.939-82.977-16.468-125.759-16.468c-42.781,0-84.933,5.529-125.77,16.469V187.678H130.234z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M163.353,264.456c4.557,0,8.251-3.694,8.251-8.251v-35.753h18.151 c10.008,0,18.151,8.142,18.151,18.151v17.601c0,4.557,3.694,8.251,8.251,8.251s8.251-3.694,8.251-8.251v-17.601 c0-10.568-4.761-20.042-12.245-26.403c7.483-6.361,12.245-15.833,12.245-26.403c0-19.109-15.545-34.654-34.654-34.654h-26.403 c-4.557,0-8.251,3.694-8.251,8.251v96.808C155.102,260.762,158.796,264.456,163.353,264.456z M171.604,167.648h18.151 c10.008,0,18.151,8.142,18.151,18.151c0,10.008-8.142,18.151-18.151,18.151h-18.151V167.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M306.843,264.456c4.558,0,8.251-3.694,8.251-8.251v-35.753h18.151 c19.107,0,34.654-15.545,34.654-34.654s-15.546-34.654-34.654-34.654h-26.403c-4.558,0-8.251,3.694-8.251,8.251v96.808 C298.591,260.762,302.285,264.456,306.843,264.456z M315.094,167.648h18.151c10.009,0,18.151,8.142,18.151,18.151 c0,10.008-8.142,18.151-18.151,18.151h-18.151V167.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M260.414,264.456c4.558,0,8.251-3.694,8.251-8.251v-96.808c0-4.557-3.693-8.251-8.251-8.251 c-4.557,0-8.251,3.694-8.251,8.251v96.808C252.163,260.762,255.856,264.456,260.414,264.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M366.56,292.737c0-4.557-3.693-8.251-8.251-8.251H153.69c-4.557,0-8.251,3.694-8.251,8.251 c0,4.557,3.694,8.251,8.251,8.251h204.619C362.866,300.988,366.56,297.295,366.56,292.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M343.311,327.391c0-4.557-3.693-8.251-8.251-8.251H176.94c-4.557,0-8.251,3.694-8.251,8.251 c0,4.557,3.694,8.251,8.251,8.251h158.121C339.617,335.642,343.311,331.948,343.311,327.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M508.168,470.663c-12.293-7.924-24.913-15.225-37.809-21.915 c2.612-9.663,11.315-32.998,35.583-39.698c4.392-1.212,6.971-5.757,5.757-10.15c-1.213-4.392-5.75-6.973-10.15-5.757 c-14.496,4.002-24.782,12.219-32.029,21.205c0.44-22.133,9.267-42.874,24.965-58.572c3.223-3.222,3.223-8.446,0.001-11.668 c-3.223-3.222-8.448-3.222-11.668,0c-14.52,14.518-24.103,32.653-27.932,52.371c-4.218-6.961-9.299-13.465-15.201-19.367 c-3.221-3.221-8.446-3.222-11.668,0c-3.222,3.222-3.222,8.447,0.001,11.669c13.94,13.94,22.449,31.858,24.491,51.192 c-11.474-5.341-23.144-10.208-34.988-14.583V187.673c0-89.065-72.46-161.525-161.525-161.525 c-89.059,0-161.514,72.46-161.514,161.525v237.716c-11.846,4.375-23.517,9.242-34.992,14.584 c2.043-19.335,10.55-37.253,24.491-51.192c3.222-3.222,3.222-8.446,0-11.668c-3.222-3.222-8.447-3.222-11.668,0 c-5.902,5.902-10.982,12.406-15.2,19.366c-3.829-19.717-13.412-37.851-27.931-52.37c-3.222-3.222-8.447-3.222-11.668,0 c-3.222,3.222-3.222,8.447,0,11.668c15.699,15.7,24.525,36.441,24.966,58.573c-7.247-8.988-17.532-17.204-32.03-21.207 c-4.392-1.212-8.937,1.364-10.15,5.757c-1.213,4.393,1.365,8.938,5.757,10.15c24.279,6.703,32.979,30.053,35.586,39.697 c-12.896,6.69-25.517,13.992-37.811,21.916c-3.076,1.982-4.479,5.754-3.445,9.266c1.033,3.511,4.255,5.921,7.916,5.921h495.395 c3.659,0,6.881-2.41,7.915-5.921C512.645,476.418,511.244,472.646,508.168,470.663z M110.984,187.673 c0-79.966,65.052-145.022,145.011-145.022c79.966,0,145.022,65.057,145.022,145.022v231.979 c-46.48-15.2-95.348-23.048-145.019-23.048c-49.67,0-98.536,7.849-145.015,23.047L110.984,187.673L110.984,187.673z  M38.125,469.347c66.437-36.875,141.169-56.242,217.874-56.242s151.436,19.367,217.874,56.242H38.125z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTombstone);
export default __webpack_public_path__ + "static/media/tombstone.46ef86ea6471f5dae1f4434b124bf897.svg";
export { ForwardRef as ReactComponent };